/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';
import { object2FormData } from '@gp/utils/common';

import type { IBaseResponse } from '@home/types/common';
import type { BoolFlag } from '@gp/enums/common';
import type { IDPSReportType, IDPSReportCoreDTO } from '@gp/types/dpsReport/common';
import type { IDPSReportEmailDTO } from '@gp/pages/Pipeline/DPSReport/components/EmailSender/types';

interface IDPSReportActionBaseParams {
  type: IDPSReportType;
  id: string;
  report_id: string;
}

interface IDPSReportSendEmailFailedFeedback {
  // 发送失败的邮箱
  email: string;
  // 失败的原因
  msg: string;
}

type IDPSReportSendEmailParams = Omit<IDPSReportEmailDTO, 'recipients'> & {
  recipients: string[];
};

/**
 * 获取DPS周报简要信息列表
 * @returns DPS周报简要信息列表
 */
export const fetchDPSReportsSummary = async (): IBaseResponse<{ list: IDPSReportCoreDTO[] | null }> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/report_list',
    method: 'GET',
    params: {},
    rawData: true,
  }) as any;
};

/**
 * 删除DPS周报
 * @param id DPS周报ID
 * @returns void
 */
export const deleteDPSReport = async (params: IDPSReportActionBaseParams): IBaseResponse<null> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/delete_weekly_report',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

/**
 * 更新DPS周报发布状态
 * @param params 参数对象
 * @param params.type 周报类型
 * @param params.id 周报ID
 * @param params.report_id 周报ID
 * @param params.is_publish 是否发布
 */
export const updateDPSReportPublishState = (params: {
  // 周报类型
  type: string;
  id: string;
  report_id: string;
  // 是否发布
  is_publish: BoolFlag;
}) => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/publish_weekly_report',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

/**
 * 发送邮件
 * @param params 参数对象
 */
export const sendEmail = (
  params: IDPSReportSendEmailParams,
): IBaseResponse<{ list: IDPSReportSendEmailFailedFeedback[] | null }> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/send_email_v3',
    method: 'POST',
    data: object2FormData(params),
    headers: { 'Content-type': 'multipart/form-data; charset=utf-8;' },
    rawData: true,
  }) as any;
};
